import axios from 'axios'
import React, { useEffect } from 'react'
import { useState } from 'react'

const UseTravelSecure = () => {

    const [name, setName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [destination, setDestination] = useState('')
    const [arrival, setArrival] = useState('')
    const [departure, setDeparture] = useState('')
    const [qtyPersons, setQtyPersons] = useState('1')
    const [msgError, setMsgError] = useState(false)
    const [dateArrival, setDateArrival] = useState()
    const [dateDeparture, setDateDeparture] = useState()
    const [selectedDateDeparture, setSelectedDateDeparture] = useState(new Date())
    const [selectedDateArrival, setSelectedDateArrival] = useState(new Date())
    const [succesScreen, setSuccesScreen] = useState(false)
    const [dataSucces, setDataSucces] = useState({})
    
    const handleDateChangeArrival = date => {
        // Crear un objeto Date con la fecha proporcionada
        const fechaObjeto = new Date(date);
        
        // Obtener los componentes de la fecha
        const anio = fechaObjeto.getFullYear();
        const mes = ("0" + (fechaObjeto.getMonth() + 1)).slice(-2);  // Agregar un cero al mes si es necesario
        const dia = ("0" + fechaObjeto.getDate()).slice(-2);  // Agregar un cero al día si es necesario
        
        // Crear la cadena de fecha en el formato deseado
        const fechaConvertida = anio + "-" + mes + "-" + dia;
        
        // Devolver la fecha convertida
        setDateArrival(fechaConvertida)
        setSelectedDateArrival(date)
    };

   
    


    const handleDateChangeDeparture = date => {
        // Crear un objeto Date con la fecha proporcionada
        const fechaObjeto = new Date(date);
        
        // Obtener los componentes de la fecha
        const anio = fechaObjeto.getFullYear();
        const mes = ("0" + (fechaObjeto.getMonth() + 1)).slice(-2);  // Agregar un cero al mes si es necesario
        const dia = ("0" + fechaObjeto.getDate()).slice(-2);  // Agregar un cero al día si es necesario
        
        // Crear la cadena de fecha en el formato deseado
        const fechaConvertida = anio + "-" + mes + "-" + dia;

        // Devolver la fecha convertida
        setDateDeparture(fechaConvertida)
        setSelectedDateDeparture(date)
    };

const findInsurance = (e)=>{
    e.preventDefault()
    if(name === '' || lastName === '' || email === '' || phone === '' || destination === '' || dateArrival === '' || dateDeparture === '' || qtyPersons === ''){
        setMsgError(true)
        setTimeout(() => {
            setMsgError(false)
        }, 5000);
    }else{
        axios.post('https://sow.pdtcomunicaciones.com/api/sures',
        {
            "name":name,
            "lastname":lastName,
            "email":email,
            "tel":phone,
            "destination":destination,
            "arrival":dateArrival,
            "departure":dateDeparture,
            "qty":qtyPersons
          }
        )
        .then(res=>{
            setDataSucces(res.data)
            setSuccesScreen(true)
        })
        .catch(err=>{
            console.log(err)
        })
    }
}





  return {
    findInsurance,
    name,
    setName,
    lastName,
    setLastName,
    email,
    setEmail,
    phone,
    setPhone,
    destination,
    setDestination,
    arrival,
    setArrival,
    departure,
    setDeparture,
    msgError,
    dateArrival, 
    setDateArrival,
    dateDeparture,
    setDateDeparture,
    handleDateChangeArrival,
    handleDateChangeDeparture,
    selectedDateArrival,
    selectedDateDeparture,
    setQtyPersons,
    dataSucces,
    succesScreen
  }
}

export default UseTravelSecure